import {
    ResultObj,
    allFetch,
} from "../Domain";

/**
 * 代碼檔大 的欄位
 */
export type SppParams = {
    spp_id: '',
    su: '',
    name: '',
    remark: ''
}

/**
 * 代碼檔中 的欄位
 */
export type SpsParams = {
    spp_id: '',
    sps_id: '',
    name: '',
    remark: '',
    visible: ''
}
/**
 * @description 查詢大分類
 * @returns res
 */
export const PrimaryList = async (): Promise<ResultObj> =>
    await allFetch("SystemParam/PrimaryList");

/**
 * @description 新增大分類
 * @param {string}  spp_id 大分類代碼
 * @param {string}  su 是否系統使用
 * @param {string}  name 名稱
 * @param {string}  remark 備註
 * @returns res
 */
export interface AddPrimaryParams {
    spp_id: string;
    su: string;
    name: string;
    remark: string;
}
export const AddPrimary = async (params: AddPrimaryParams): Promise<ResultObj> =>
    await allFetch("SystemParam/AddPrimary", params);

/**
 * @description 查詢大分類細項
 * @param {string}  spp_id 大分類代碼
 * @returns res
 */
export interface PrimaryDetailParams {
    spp_id: string;
}
export const PrimaryDetail = async (params: PrimaryDetailParams): Promise<ResultObj> =>
    await allFetch("SystemParam/PrimaryDetail", params);

/**
 * @description 修改大分類
 * @param {string}  spp_id 大分類代碼
 * @param {string}  su 是否系統使用
 * @param {string}  name 名稱
 * @param {string}  remark 備註
 * @returns res
 */
export interface UpdatePrimaryParams {
    spp_id: string;
    su: string;
    name: string;
    remark: string;
}
export const UpdatePrimary = async (params: UpdatePrimaryParams): Promise<ResultObj> =>
    await allFetch("SystemParam/UpdatePrimary", params);

/**
 * @description 查詢中分類
 * @param {string}  spp_id 大分類代碼
 * @param {string}  visible 是否可見
 * @returns res
 */
export interface SecondListParams {
    spp_id: string;
    visible: string;
}
/**@description 查詢中分類 (回傳) */
export interface SecondListResItem {
    code: string;
    name: string;
    remark: string;
    seq: number;
    spp_id: string;
    sps_id: string;
    visible: string;
}

export const SecondList = async (params: SecondListParams): Promise<ResultObj<SecondListResItem[]>> =>
    await allFetch("SystemParam/SecondList", params);

/**
 * @description 修改中分類
 * @param {string}  spp_id 大分類代碼
 * @param {string}  sps_id 中分類代碼
 * @param {string}  su 是否系統使用
 * @param {string}  name 名稱
 * @param {string}  remark 備註
 * @param {string}  visible 是否可見
 * @returns res
 */
export interface UpdateSecondParams {
    spp_id: string;
    sps_id: string;
    name: string;
    remark: string;
    visible: string;
}
export const UpdateSecond = async (params: UpdateSecondParams): Promise<ResultObj> =>
    await allFetch("SystemParam/UpdateSecond", params);

/**
 * @description 新增中分類 
 * @param {string}  spp_id 大分類代碼
 * @param {string}  name 名稱
 * @param {string}  remark 備註
 * @returns res
 */
export interface AddSecondParams {
    spp_id: string;
    name: string;
    remark: string;
}
export const AddSecond = async (params: AddSecondParams): Promise<ResultObj> =>
    await allFetch("SystemParam/AddSecond", params);

/**
* @description 刪除中分類
* @param {string}  spp_id 大分類代碼
* @param {string}  sps_id 中分類代碼
* @returns res
*/
export interface DeleteSecondParams {
    spp_id: string;
    sps_id: string;
}
export const DeleteSecond = async (params: DeleteSecondParams): Promise<ResultObj> =>
    await allFetch("SystemParam/DeleteSecond", params);
